export default "__VITE_ASSET__3ec7d476__"